export const OFFER_TEST_IDS = {
    OFFER_VIEW: {
        PRICE_BUTTON: "offer-price-button",
        PRICE_BUTTON_MOBILE: "offer-price-button-mobile",
        CALL_BUTTON_MOBILE: "call-button-mobile",
        PROPERTY_BOX: (propertyId: string) => `property-${propertyId}`,
        PROPERTY_ASK_FOR_PRICE_BUTTON: "property-ask-for-price-button",
        PHONE_MODAL_SEND_BUTTON: "phone-modal-send-button",
        PHONE_MODAL_NUMBER_PLACEHOLDER: "phone-modal-number-placeholder",
        PHONE_MODAL_SUCCESS_INFO: "phone-modal-success-info",
        PHONE_MODAL_GO_BACK_BUTTON: "phone-modal-go-back-button"
    },
    LISTING_OFFER_BOX: {
        PROPERTY_VIEW_BUTTON: "property-view-button",
        PROPERTY_VIEW_BOX(propertyId: number) {
            return `property-${propertyId}`;
        }
    },
    LEAD_FORM: {
        PREMULTILEAD_CHECKBOX: "preMultiLead-checkbox",
        FORM_NAME_INPUT: "form-name-input",
        FORM_EMAIL_INPUT: "form-email-input",
        FORM_PHONE_INPUT: "form-phone-input",
        SEND_LEAD_BUTTON: "send-lead-button",
        CONFIRM_SEND_LEAD_BUTTON: "confirm-send-lead-button",
        PROPERTY_PRICE_REVEALED_MODAL: "property-price-revealed-modal",
        MULTILEAD_SUMMARY_HEADER: "multilead-summary-header",
        MULTILEAD_SUMMARY_TABLE: "multilead-summary-table",
        MULTILEAD_SUMMARY_ITEM: "multilead-summary-item",
        EXPAND_OFFER_BUTTON_MOBILE: "expand-offer-button-mobile"
    }
};
